import React from 'react';
import { BarChartIcon, TrendingUpIcon, SearchIcon } from 'lucide-react';
export const Analytics: React.FC = () => {
  return <div className="space-y-4" data-id="element-1043">
      <div className="flex items-center justify-between mb-4" data-id="element-1044">
        <h1 className="text-2xl font-bold text-secondary flex items-center" data-id="element-1045">
          <BarChartIcon size={24} className="mr-2" data-id="element-1046" />
          Summary & AI Analytics
        </h1>
        <div className="flex space-x-2" data-id="element-1047">
          <button className="bg-secondary text-white px-4 py-2 rounded-md hover:bg-opacity-90" data-id="element-1048">
            Ekspor PDF
          </button>
          <button className="bg-primary text-secondary px-4 py-2 rounded-md hover:bg-opacity-90 font-medium" data-id="element-1049">
            Generate Report
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-id="element-1050">
        <div className="lg:col-span-2" data-id="element-1051">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1052">
            <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-1053">
              <h2 className="font-bold text-secondary" data-id="element-1054">Ringkasan Nasional</h2>
            </div>
            <div className="p-4" data-id="element-1055">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4" data-id="element-1056">
                <div className="bg-neutral-light p-3 rounded-lg" data-id="element-1057">
                  <h3 className="text-xs text-gray-500 mb-1" data-id="element-1058">TOTAL ASET</h3>
                  <p className="text-xl font-bold text-secondary" data-id="element-1059">3,452</p>
                </div>
                <div className="bg-neutral-light p-3 rounded-lg" data-id="element-1060">
                  <h3 className="text-xs text-gray-500 mb-1" data-id="element-1061">NILAI ASET</h3>
                  <p className="text-xl font-bold text-secondary" data-id="element-1062">Rp 1.2T</p>
                </div>
                <div className="bg-neutral-light p-3 rounded-lg" data-id="element-1063">
                  <h3 className="text-xs text-gray-500 mb-1" data-id="element-1064">ASET KRITIS</h3>
                  <p className="text-xl font-bold text-accent-red" data-id="element-1065">127</p>
                </div>
                <div className="bg-neutral-light p-3 rounded-lg" data-id="element-1066">
                  <h3 className="text-xs text-gray-500 mb-1" data-id="element-1067">KONTRAK AKTIF</h3>
                  <p className="text-xl font-bold text-accent-info" data-id="element-1068">78</p>
                </div>
              </div>
              <div className="space-y-4" data-id="element-1069">
                <div data-id="element-1070">
                  <h3 className="text-sm font-medium text-secondary mb-2" data-id="element-1071">
                    Distribusi Aset per Entitas
                  </h3>
                  <div className="h-64 bg-neutral-light rounded-lg p-3 flex items-end space-x-4" data-id="element-1072">
                    <div className="flex flex-col items-center" data-id="element-1073">
                      <div className="bg-primary h-32 w-12 rounded-t-md" data-id="element-1074"></div>
                      <p className="text-xs mt-1" data-id="element-1075">Pusat/Setuma</p>
                      <p className="text-xs font-medium" data-id="element-1076">32%</p>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-1077">
                      <div className="bg-primary h-44 w-12 rounded-t-md" data-id="element-1078"></div>
                      <p className="text-xs mt-1" data-id="element-1079">Deputi</p>
                      <p className="text-xs font-medium" data-id="element-1080">45%</p>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-1081">
                      <div className="bg-primary h-20 w-12 rounded-t-md" data-id="element-1082"></div>
                      <p className="text-xs mt-1" data-id="element-1083">STIN</p>
                      <p className="text-xs font-medium" data-id="element-1084">18%</p>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-1085">
                      <div className="bg-primary h-52 w-12 rounded-t-md" data-id="element-1086"></div>
                      <p className="text-xs mt-1" data-id="element-1087">BINDA</p>
                      <p className="text-xs font-medium" data-id="element-1088">52%</p>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-1089">
                      <div className="bg-primary h-24 w-12 rounded-t-md" data-id="element-1090"></div>
                      <p className="text-xs mt-1" data-id="element-1091">Satker</p>
                      <p className="text-xs font-medium" data-id="element-1092">22%</p>
                    </div>
                  </div>
                </div>
                <div data-id="element-1093">
                  <h3 className="text-sm font-medium text-secondary mb-2" data-id="element-1094">
                    Distribusi Nilai Aset
                  </h3>
                  <div className="h-64 bg-neutral-light rounded-lg p-3 flex items-center justify-center" data-id="element-1095">
                    <div className="w-48 h-48 rounded-full border-8 border-primary relative" data-id="element-1096">
                      <div className="absolute inset-0 border-t-8 border-r-8 border-accent-info rounded-full" style={{
                      clipPath: 'polygon(0 0, 100% 0, 100% 50%, 0 50%)'
                    }} data-id="element-1097"></div>
                      <div className="absolute inset-0 border-b-8 border-l-8 border-accent-green rounded-full" style={{
                      clipPath: 'polygon(0 50%, 100% 50%, 100% 100%, 0 100%)'
                    }} data-id="element-1098"></div>
                      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center" data-id="element-1099">
                        <p className="text-xl font-bold text-secondary" data-id="element-1100">
                          Rp 1.2T
                        </p>
                        <p className="text-xs text-gray-600" data-id="element-1101">
                          Total Nilai Aset
                        </p>
                      </div>
                    </div>
                    <div className="ml-8 space-y-2" data-id="element-1102">
                      <div className="flex items-center" data-id="element-1103">
                        <span className="w-3 h-3 bg-primary rounded-full mr-2" data-id="element-1104"></span>
                        <span className="text-xs" data-id="element-1105">Perangkat Keras (45%)</span>
                      </div>
                      <div className="flex items-center" data-id="element-1106">
                        <span className="w-3 h-3 bg-accent-info rounded-full mr-2" data-id="element-1107"></span>
                        <span className="text-xs" data-id="element-1108">
                          Software & Lisensi (25%)
                        </span>
                      </div>
                      <div className="flex items-center" data-id="element-1109">
                        <span className="w-3 h-3 bg-accent-green rounded-full mr-2" data-id="element-1110"></span>
                        <span className="text-xs" data-id="element-1111">
                          Bangunan & Kendaraan (30%)
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="space-y-4" data-id="element-1112">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1113">
            <div className="p-3 border-b border-gray-200 bg-neutral-light flex items-center justify-between" data-id="element-1114">
              <h2 className="font-bold text-secondary flex items-center" data-id="element-1115">
                <TrendingUpIcon size={18} className="mr-2 text-accent-info" data-id="element-1116" />
                AI Narrative Report
              </h2>
              <span className="text-xs bg-accent-info text-white px-2 py-1 rounded" data-id="element-1117">
                Powered by AI
              </span>
            </div>
            <div className="p-4" data-id="element-1118">
              <div className="space-y-3 text-sm text-gray-700" data-id="element-1119">
                <p data-id="element-1120">
                  <strong className="text-secondary" data-id="element-1121">
                    Ringkasan Eksekutif:
                  </strong>{' '}
                  Analisis menunjukkan bahwa aset BIN saat ini berada dalam
                  kondisi baik (72% aktif), namun terdapat 127 aset kritis yang
                  memerlukan perhatian segera.
                </p>
                <p data-id="element-1122">
                  <strong className="text-secondary" data-id="element-1123">Temuan Utama:</strong>{' '}
                  BINDA memiliki 52% dari total aset nasional, dengan nilai aset
                  terbesar berada di Pusat/Setuma (Rp 450M). Terdapat 78 kontrak
                  aktif dengan nilai total Rp 850M.
                </p>
                <p data-id="element-1124">
                  <strong className="text-secondary" data-id="element-1125">Rekomendasi:</strong>{' '}
                  Prioritaskan pembaruan 15 server yang akan mencapai EOL dalam
                  6 bulan ke depan. Pertimbangkan konsolidasi lisensi software
                  untuk menghemat hingga 18% biaya tahunan.
                </p>
                <p data-id="element-1126">
                  <strong className="text-secondary" data-id="element-1127">Proyeksi:</strong> Dengan
                  pola saat ini, diproyeksikan kebutuhan anggaran pemeliharaan
                  akan meningkat 12% pada tahun 2024, terutama untuk aset di
                  BINDA dan STIN.
                </p>
              </div>
              <div className="mt-4 flex justify-end" data-id="element-1128">
                <button className="bg-accent-info text-white px-3 py-1.5 rounded text-sm" data-id="element-1129">
                  Ekspor Laporan Lengkap
                </button>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1130">
            <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-1131">
              <h2 className="font-bold text-secondary" data-id="element-1132">
                Smart Query (Bahasa Alami)
              </h2>
            </div>
            <div className="p-4" data-id="element-1133">
              <div className="relative mb-4" data-id="element-1134">
                <input type="text" placeholder="Buat ringkasan aset STIN di atas Rp1 Miliar..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" data-id="element-1135" />
                <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-1136" />
              </div>
              <div className="space-y-2" data-id="element-1137">
                <div className="text-xs text-gray-500" data-id="element-1138">Contoh query:</div>
                <button className="text-xs bg-gray-100 hover:bg-gray-200 px-2 py-1 rounded mr-2 mb-2 inline-block" data-id="element-1139">
                  Tampilkan aset kritis di BINDA Jawa Timur
                </button>
                <button className="text-xs bg-gray-100 hover:bg-gray-200 px-2 py-1 rounded mr-2 mb-2 inline-block" data-id="element-1140">
                  Bandingkan nilai aset Deputi I dan Deputi II
                </button>
                <button className="text-xs bg-gray-100 hover:bg-gray-200 px-2 py-1 rounded mr-2 mb-2 inline-block" data-id="element-1141">
                  Aset dengan kontrak berakhir dalam 90 hari
                </button>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1142">
            <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-1143">
              <h2 className="font-bold text-secondary" data-id="element-1144">
                Wilayah/Entitas Paling Kritis
              </h2>
            </div>
            <div className="p-4" data-id="element-1145">
              <div className="space-y-3" data-id="element-1146">
                <div className="flex items-center justify-between" data-id="element-1147">
                  <div className="flex items-center" data-id="element-1148">
                    <span className="w-2 h-2 bg-accent-red rounded-full mr-2" data-id="element-1149"></span>
                    <span className="text-sm" data-id="element-1150">BINDA Sumatera Barat</span>
                  </div>
                  <span className="text-xs bg-red-100 text-red-800 px-2 py-0.5 rounded-full" data-id="element-1151">
                    12 Aset Kritis
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-1152">
                  <div className="flex items-center" data-id="element-1153">
                    <span className="w-2 h-2 bg-accent-red rounded-full mr-2" data-id="element-1154"></span>
                    <span className="text-sm" data-id="element-1155">Pusat Data Setuma</span>
                  </div>
                  <span className="text-xs bg-red-100 text-red-800 px-2 py-0.5 rounded-full" data-id="element-1156">
                    9 Aset Kritis
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-1157">
                  <div className="flex items-center" data-id="element-1158">
                    <span className="w-2 h-2 bg-accent-red rounded-full mr-2" data-id="element-1159"></span>
                    <span className="text-sm" data-id="element-1160">STIN</span>
                  </div>
                  <span className="text-xs bg-red-100 text-red-800 px-2 py-0.5 rounded-full" data-id="element-1161">
                    8 Aset Kritis
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1162">
        <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-1163">
          <h2 className="font-bold text-secondary" data-id="element-1164">Summary per Unit</h2>
        </div>
        <div className="overflow-x-auto" data-id="element-1165">
          <table className="w-full" data-id="element-1166">
            <thead className="bg-neutral-light" data-id="element-1167">
              <tr data-id="element-1168">
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1169">
                  Unit
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1170">
                  Total Aset
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1171">
                  Nilai Aset
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1172">
                  Kondisi Baik
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1173">
                  Perlu Perawatan
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1174">
                  Kritis
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1175">
                  Kontrak Aktif
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1176">
                  Rekomendasi
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-1177">
              <tr className="hover:bg-neutral-light" data-id="element-1178">
                <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-1179">
                  Pusat/Setuma
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1180">587</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1181">Rp 450M</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1182">75%</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1183">15%</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1184">10%</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1185">24</td>
                <td className="px-4 py-3 text-sm" data-id="element-1186">
                  <button className="text-accent-info hover:underline" data-id="element-1187">
                    Lihat (12)
                  </button>
                </td>
              </tr>
              <tr className="hover:bg-neutral-light" data-id="element-1188">
                <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-1189">
                  STIN
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1190">312</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1191">Rp 280M</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1192">68%</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1193">22%</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1194">10%</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1195">15</td>
                <td className="px-4 py-3 text-sm" data-id="element-1196">
                  <button className="text-accent-info hover:underline" data-id="element-1197">
                    Lihat (8)
                  </button>
                </td>
              </tr>
              <tr className="hover:bg-neutral-light" data-id="element-1198">
                <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-1199">
                  BINDA Jawa Timur
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1200">215</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1201">Rp 175M</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1202">72%</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1203">18%</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1204">10%</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1205">12</td>
                <td className="px-4 py-3 text-sm" data-id="element-1206">
                  <button className="text-accent-info hover:underline" data-id="element-1207">
                    Lihat (6)
                  </button>
                </td>
              </tr>
              <tr className="hover:bg-neutral-light" data-id="element-1208">
                <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-1209">
                  BINDA Sumatera Barat
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1210">187</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1211">Rp 145M</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1212">62%</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1213">20%</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1214">18%</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1215">9</td>
                <td className="px-4 py-3 text-sm" data-id="element-1216">
                  <button className="text-accent-info hover:underline" data-id="element-1217">
                    Lihat (12)
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};